/* eslint-disable indent */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/camelcase */
import { Divider, Grid, makeStyles } from '@material-ui/core';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import Permission from 'components/ValidPermission';
import EditIcon from '@material-ui/icons/Edit';
import clsx from 'clsx';
import Button from 'components/Button';
import PageTitle from 'components/PageTitle';
import i18n from 'i18n';
import {
  CompanyData,
  RolesEnum,
  PermissionsData,
} from 'modules/authenticate/interfaces';
import {
  editOperatorRequest,
  getOperatorRequest,
} from 'modules/operators/actions';
import { GetOperatorFields } from 'modules/operators/interfaces';
import React from 'react';
import { connect } from 'react-redux';
import { useParams, Redirect } from 'react-router';
import { useHistory } from 'react-router-dom';
import ApplicationState from 'store/interfaces';
import { inAdminView, inOperatorView, inSuperAdminView } from 'utils/role';
import Dashboard from 'containers/Dashboard';
import FormOperator from '../Form';
import ProfileCard from '../ProfileCard';
import styles from './styles';
import TokenAPISection from './TokenAPISection';

const useStyles = makeStyles(styles);

interface Props {
  companySelected: CompanyData | null;
  isLoading: boolean;
  operator: GetOperatorFields | null;
  operator_uuid: string;
  permissions?: PermissionsData;
  role?: RolesEnum;
  getOperatorRequest: (id: string) => void;
  editOperatorRequest: ({ values, state }) => void;
}

const EditOperator = ({
  companySelected,
  isLoading,
  operator,
  operator_uuid,
  permissions,
  role,
  getOperatorRequest,
  editOperatorRequest,
}: Props) => {
  const [values, setValues] = React.useState<any>(null);
  const { id } = useParams<{ id: string }>();
  const [saveButton, setSaveButton] = React.useState(false);
  const history = useHistory();

  const classes = useStyles();

  const handleSubmit = values => {
    editOperatorRequest({ values, state: history.location.state });
  };

  React.useEffect(() => {
    getOperatorRequest(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, getOperatorRequest]);

  React.useEffect(() => {
    setValues({
      ...operator,
      phone: operator?.phone || '',
      company_uuid: operator?.company?.company_uuid,
    });
  }, [operator]);

  if (
    (id !== operator_uuid && !permissions?.edit_operator_details) ||
    (id === operator_uuid && !permissions?.list_self_operator_details)
  ) {
    return <Dashboard component={<Redirect to={'/notPermission'} />} />;
  }

  return (
    <Grid container>
      {id === operator_uuid && (
        <Grid container>
          <Grid container className={classes.header}>
            <Grid container xs={6}>
              <PageTitle
                title={i18n.t('OPERATORS_PAGE.EDIT_OPERATOR_TITLE_KEY')}
                subtitle={i18n.t('OPERATORS_PAGE.EDIT_OPERATOR_SUBTITLE_KEY')}
              />
            </Grid>
            <Permission value="edit_self_operator_details">
              <Grid
                container
                justify="flex-end"
                xs={6}
                className={classes.upperButton}
              >
                {saveButton ? (
                  <Button
                    startIcon={<ChevronLeftIcon className={classes.editIcon} />}
                    variant="outlined"
                    className={clsx(classes.buttonDefault, {
                      [classes.buttonSuperAdmin]: inSuperAdminView(
                        role,
                        companySelected
                      ),
                      [classes.buttonAdmin]: inAdminView(role, companySelected),
                      [classes.buttonOperator]: inOperatorView(
                        role,
                        companySelected
                      ),
                    })}
                    id="back-button"
                    onClick={() => setSaveButton(!saveButton)}
                  >
                    {i18n.t('BACK_KEY')}
                  </Button>
                ) : (
                  <Button
                    startIcon={<EditIcon className={classes.editIcon} />}
                    variant="outlined"
                    className={clsx(classes.buttonDefault, {
                      [classes.buttonSuperAdmin]: inSuperAdminView(
                        role,
                        companySelected
                      ),
                      [classes.buttonAdmin]: inAdminView(role, companySelected),
                      [classes.buttonOperator]: inOperatorView(
                        role,
                        companySelected
                      ),
                    })}
                    id="edit-button"
                    onClick={() => {
                      setSaveButton(!saveButton);
                    }}
                  >
                    {i18n.t('EDIT_KEY')}
                  </Button>
                )}
              </Grid>
            </Permission>
          </Grid>
          {saveButton ? (
            <Grid className={classes.edit}>
              <FormOperator
                onCancel={() => setSaveButton(false)}
                isEdit
                initialValues={values}
                isLoading={isLoading}
                onSubmit={handleSubmit}
              />
              <Divider className={classes.divider} />
            </Grid>
          ) : (
            <Grid className={classes.profile}>
              <ProfileCard
                isEdit
                initialValues={values}
                isLoading={isLoading}
                onSubmit={handleSubmit}
              />
              <Divider className={classes.divider} />
            </Grid>
          )}
        </Grid>
      )}
      {id !== operator_uuid && (
        <Grid container className={classes.header}>
          <Grid container xs={6}>
            <PageTitle
              title={i18n.t('OPERATORS_PAGE.EDIT_OPERATOR_TITLE_KEY')}
              subtitle={i18n.t('OPERATORS_PAGE.EDIT_OPERATOR_SUBTITLE_KEY')}
            />
          </Grid>
          <Grid className={classes.edit}>
            <FormOperator
              onCancel={() => history.push('/operators')}
              isEdit
              initialValues={values}
              isLoading={isLoading}
              onSubmit={handleSubmit}
            />
            <Divider className={classes.divider} />
          </Grid>
        </Grid>
      )}

      <TokenAPISection />
    </Grid>
  );
};

const mapStateToProps = ({
  authenticate: { data, companySelected },
  operators: { isLoading, operatorDetails },
}: ApplicationState) => ({
  isLoading,
  operator_uuid: data?.operator_uuid!,
  operator: operatorDetails,
  permissions: data?.permissions,
  role: data?.role,
  companySelected,
});

export default connect(mapStateToProps, {
  editOperatorRequest,
  getOperatorRequest,
})(EditOperator);
